module.exports = __webpack_public_path__ + "static/media/stock_c_to_c_example.1ff71ae1.png";